import { editorAddText } from '~core';
import $ from 'jquery';

export const onAddQuoteToCanvas = async (event) => {
  event.preventDefault();
  const quote = $(event.currentTarget).data('text');

  // Check if there's an active textbox object
  const activeObject = window.canvas.getActiveObject();

  if (activeObject && activeObject.type === 'textbox') {
    // Reuse the active textbox by replacing its text
    activeObject.set('text', quote);
    window.canvas.renderAll();
  } else {
    // No active textbox, create a new one
    await editorAddText('QUOTES', quote);
  }
};
